export enum UserKeys {
    GetUsersByStore = 'usersbystore',
    GetStores = 'stores',
    GetuserByUserName = 'userbyusername',
}